module.exports = __webpack_public_path__ + "static/img/simg.3208187.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/simg.png
// module id = nvlW
// module chunks = 2